import axios from 'axios'
import { displayNotification } from '../../actions/notificationsActions'

export const fetchBusinessConfig = () => (dispatch) => {
  return axios
    .get(`${process.env.REACT_APP_BLINKER_API_URL}/api/v3/configuration`)
    .then((response) => {
      const businessConfig = response.data
      dispatch({
        type: 'FETCH_BUSINESS_CONFIG_SUCCESS',
        businessConfig,
      })
      return businessConfig
    })
    .catch((error) => {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : 'Something went wrong'
      dispatch({
        type: 'FETCH_BUSINESS_CONFIG_FAILURE',
      })
      dispatch(displayNotification(`${errorMessage}`, 'error'))
      throw new Error(error)
    })
}
